import { styled } from 'stitches.config'

export const HeroRoot = styled('div', {
  background: '$secondary-500',
  color: '$accent-white',
  width: '100%',
})

export const HeroFlex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '500px',
  margin: 'auto',

  '@bp2': {
    flexDirection: 'row',
    maxWidth: '2100px',
  },
})

export const ImageColumn = styled('div', {
  lineHeight: 0,
  width: '100%',

  '@bp2': {
    width: '49.2%'
  }
})

export const CopyColumn = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '52px 16px',
  '@bp2': {
    padding: '32px',
    width: '50.8%',
  },
})

export const ImageWrapper = styled('div', {})

export const Header = styled('h1', {
  textAlign: 'center',
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',
  width: '100%',
  maxWidth: '300px',

  '@bp3': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
    maxWidth: '580px',
  },
})
